export default {
  namespaced: true,

  state: {
    list: null,
    expose: {
    },
    calendar: {
    }
  },

  mutations: {
    list(state, list) {
      state.list = list;

      const exposeList = [];
      list.forEach(e => {
        exposeList[e.exposeId] = e;
      });

      state.expose = exposeList;
    },

    calendar(state, calendar) {
      const o = {};
      Object.keys(state.calendar).forEach(id => {
        o[id] = state.calendar[id];
      });
      o[calendar.exposeId] = calendar;
      state.calendar = o;
    }
  },

  actions: {
    loadAll({ dispatch, commit, state }) {
      return new Promise((resolve) => {
        if (state.list === null) {
          dispatch("ajax", {
            url: "/v1/exposes"
          }, { root: true }).then((list) => {
            resolve();
            commit("list", list);
          });
        } else {
          resolve();
        }
      });
    },

    loadCalendar({ state, commit, dispatch }, opts) {
      let exposeId = null;
      let force = false;
      if (typeof(opts) == "object") {
        exposeId = opts.exposeId;
        if ("force" in opts) {
          force = opts.force;
        }
      } else {
        exposeId = opts;
      }

      if (force || !(exposeId in state.calendar)) {
        dispatch("ajax", {
          url: "/v1/exposes/" + exposeId + "/calendar"
        }, { root: true }).then(calendar => {
          const appointments = calendar.appointments;
          if (appointments && appointments.length > 0) {
            calendar.appointment = appointments[0];
          } else {
            calendar.appointment = null;
          }

          commit("calendar", {...calendar, exposeId: exposeId});
        });
      }
    },

    async createCalendarAppointment({ dispatch }, data) {
      return dispatch("ajax", {
        url: "/v1/exposes/" + data.exposeId + "/calendar",
        method: "post",
        data: data
      }, { root: true });
    },

    async deleteCalendarAppointment({ dispatch }, data) {
      return dispatch("ajax", {
        url: "/v1/exposes/" + data.exposeId + "/calendar/" + data.uuid,
        method: "delete"
      }, { root: true });
    }

/*
    async EXPOSE_LOAD_CALENDAR({ dispatch, commit }, exposeId) {
      const pList = dispatch("loadAll");
      const pCalendar = dispatch("loadCalendar", exposeId);

      dispatch("loading", true, { root: true });
      Promise.all([pList, pCalendar]).then((values) => {
        const calendar = {
          exposeId,
          days: values[1].days
        };

        if (values[1].appointments && values[1].appointments.length > 0) {
          calendar.appointment = values[1].appointments[0];
        }

        commit("calendar", calendar);
        dispatch("loading", false, { root: true });
      });
    }
*/

  }
};
